import * as React from 'react';

export function Login() {
  return (
    <div>
      <p>Log me in, bro</p>
    </div>
  );
}
